import env from '@beam-australia/react-env';

export const copyExternalHearingLinkToClipboard = (hearingId) => {
  const baseUrl = env('EXT_PUBLIC_BASE_URL');

  if (hearingId && baseUrl) {
    const url = new URL(`hearing/${hearingId}`, baseUrl);
    return copyTextToClipboard(url.toString());
  }
  console.error(
    'Failed to generate hearing link for external portal. Ensure environent is configured correctly',
  );
};

const copyTextToClipboard = (text) => {
  if (text) {
    navigator.clipboard.writeText(text);
    return;
  }
  console.error('Failed to copy empty text to clipboard');
};
